'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ChatFilterOptions = {
  STARTED: 'STARTED',
  ENDED: 'ENDED',
  SOFT_DELETED: 'SOFT_DELETED',
  INITIALIZING: 'INITIALIZING'
};

exports.default = ChatFilterOptions;
module.exports = exports['default'];